import { Injectable, signal } from '@angular/core';
import { FullStory } from '@fullstory/browser';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';
import { AccessLevel } from '../types/configuration';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly sessionId = signal<string>('');
  private readonly isMobileDevice = signal<boolean>(false);
  private readonly navMenuStatus = signal<boolean>(false);
  private readonly navMenuSubject = new ReplaySubject<boolean>();
  private readonly settingsSubject = new ReplaySubject<string>();
  private readonly sessionAccessLevel = new BehaviorSubject<AccessLevel | undefined>(undefined);
  session$ = this.settingsSubject.asObservable();
  accessLevel$ = this.sessionAccessLevel.asObservable();
  navMenuStatus$ = this.navMenuSubject.asObservable();

  updateMobileDeviceStatus(isMobileDevice: boolean): void {
    if (this.isMobileDevice() !== isMobileDevice) {
      this.isMobileDevice.set(isMobileDevice);
    }
  }

  updateSessionId(sessionId: string): void {
    if (this.sessionId() !== sessionId) {
      this.settingsSubject.next(sessionId);
      this.sessionId.set(sessionId);
    }
  }

  updateSessionUserAccess(accessLevel: AccessLevel): void {
    this.sessionAccessLevel.next(accessLevel);
  }

  toggleNavMenu(): void {
    const isNavMenuToggled = !this.navMenuStatus();
    this.navMenuStatus.set(isNavMenuToggled);
    this.navMenuSubject.next(isNavMenuToggled);
  }

  retrieveCurrentSessionId(): string {
    if (!this.sessionId()) {
      return 'NOT_INITIALIZED';
    }
    return this.sessionId();
  }

  retrieveMobileDeviceStatus(): boolean {
    if (!this.isMobileDevice()) {
      return false;
    }
    return this.isMobileDevice();
  }

  retrieveCurrentFullStorySessionId(): string {
    return FullStory('getSession', { format: 'id' }) ?? 'NOT_INITIALIZED';
  }
}
